import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { useTranslation, Trans } from 'react-i18next'

const STORAGE_KEY = 'omg_cookie_consent'

export default function CookieConsent() {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (!stored) setVisible(true)

    // Allow footer "manage cookie preferences" to reopen
    function onReset() { setVisible(true) }
    window.addEventListener('omg-cookie-reset', onReset)
    return () => window.removeEventListener('omg-cookie-reset', onReset)
  }, [])

  function acknowledge() {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      essential: true,
      acknowledged_at: new Date().toISOString(),
    }))
    setVisible(false)
  }

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="cookie-banner"
          role="dialog"
          aria-label="Cookie notice"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.33, 1, 0.68, 1] }}
        >
          <div className="cookie-content">
            <p className="cookie-text">
              <Trans i18nKey="cookie.text"
                components={{
                  privacy: <a href="/privacy" />,
                  terms: <a href="/terms" />,
                }}
              />
            </p>
            <div className="cookie-actions">
              <button className="cookie-btn cookie-accept" onClick={acknowledge}>{t('cookie.accept')}</button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
